import { Injectable } from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ResourcesService {
  public amount$: Subject<{ value: '' }> = new Subject<{value: ''}>();
  constructor() { }
}
